import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"relative","background-color":"black","opacity":"0.5","width":"100%","height":"100%"} }, null, -1)
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered mw-900px",
  style: {"position":"absolute","top":"0","bottom":"0","right":"0","left":"0"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "form fv-plugins-bootstrap5 fv-plugins-framework",
  style: {"max-height":"90vh","overflow":"scroll"}
}
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold" }, "Add Account Type", -1)
const _hoisted_7 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = {
  key: 0,
  class: "table table-row-dashed table-row-gray-200 align-middle"
}
const _hoisted_10 = {
  key: 1,
  class: "p-7"
}
const _hoisted_11 = { class: "d-flex justify-content-end" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5 mb-5" }, null, -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = {
  key: 0,
  class: "row mt-7 mb-3"
}
const _hoisted_16 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_17 = { class: "mt-5" }
const _hoisted_18 = { class: "d-flex justify-content-center" }

import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { showModal, hideModal } from "@/core/helpers/dom";
import RebateService from "../../../rebate/services/RebateService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import ResetPassword from "@/projects/client/views/auth/ResetPassword.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddTopAgentAccountType',
  emits: ["buildRelationForm"],
  setup(__props, { expose: __expose, emit }) {



const { t } = useI18n();
const isLoading = ref(true);
const productCategory = ref<any>({} as any);
const defaultLevelSetting = ref<any>({} as any);
const addTopAgentAccountTypeRef = ref<null | HTMLElement>(null);
const selectedOption = ref(0);
const ruleId = ref();
const accountType = ref();
const allowCommissions = ref([]);
const allowPips = ref([]);

const addTopAgentAccountType = async () => {
  const selectedRebateSetting = defaultLevelSetting.value[selectedOption.value];

  try {
    await RebateService.updateTopAgentRule(ruleId.value, {
      optionName: selectedRebateSetting.optionName,
      accountType: accountType.value,
      items: productCategory.value.map((category) => ({
        cid: category.key,
        r: selectedRebateSetting.category[category.key] ?? 0,
      })),
      allowPips: allowPips.value,
      allowCommissions: allowCommissions.value,
      pips: null,
      commission: null,
      percentage: 100,
    });
    MsgPrompt.success("Update Success").then(() => {
      emit("buildRelationForm");
      hideModal(addTopAgentAccountTypeRef.value);
    });
  } catch (error) {
    console.log(error);
  }
};

const reset = () => {
  isLoading.value = true;
  selectedOption.value = 0;
  allowCommissions.value = [];
  allowPips.value = [];
};

const show = async (
  _ruleId,
  _accountType,
  _productCategory,
  _defaultLevelSetting
) => {
  reset();
  showModal(addTopAgentAccountTypeRef.value);

  ruleId.value = _ruleId;
  accountType.value = _accountType;
  productCategory.value = _productCategory;
  defaultLevelSetting.value = _defaultLevelSetting[_accountType];

  isLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "kt_modal_create_deposit",
    tabindex: "-1",
    "aria-hidden": "true",
    ref_key: "addTopAgentAccountTypeRef",
    ref: addTopAgentAccountTypeRef
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr061.svg" })
              ])
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                _createElementVNode("tbody", null, [
                  _createVNode(_component_LoadingRing)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultLevelSetting.value, (option, index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: index,
                      class: _normalizeClass(["btn btn-sm btn-light-success border-0 me-3", selectedOption.value == index ? 'active' : '']),
                      onClick: ($event: any) => (selectedOption.value = index)
                    }, _toDisplayString(option.optionName), 11, _hoisted_12))
                  }), 128))
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(
                  defaultLevelSetting.value[selectedOption.value].category
                ), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-2 mb-1",
                      key: index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.clientSymbolCategory." + item)), 1),
                      _createVNode(_component_el_input, {
                        class: "w-100% h-35px mt-1 mb-1",
                        modelValue: defaultLevelSetting.value[selectedOption.value].category[item],
                        "onUpdate:modelValue": ($event: any) => ((defaultLevelSetting.value[selectedOption.value].category[item]) = $event),
                        disabled: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))
                  }), 128))
                ]),
                (
                defaultLevelSetting.value[selectedOption.value].allowPipOptions.length != 0
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)("fields.availablePips")), 1),
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: allowPips.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allowPips).value = $event)),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultLevelSetting.value[selectedOption.value]
                    .allowPipOptions, (p, index) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              class: "mt-3",
                              key: 'p_' + index,
                              label: p,
                              border: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("type.pipOptions." + p)), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (
                defaultLevelSetting.value[selectedOption.value].allowCommissionOptions
                  .length != 0
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(t)("fields.availableCommission")), 1),
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: allowCommissions.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((allowCommissions).value = $event)),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultLevelSetting.value[selectedOption.value]
                    .allowCommissionOptions, (c, index) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              class: "mt-3",
                              key: 'c_' + index,
                              label: c,
                              border: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("type.commissionOptions." + c)), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "btn btn-md btn-light-primary border-0 mb-7",
            style: {"width":"200px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (addTopAgentAccountType(_ctx.uid)))
          }, " Add Account Type ")
        ])
      ])
    ])
  ], 512))
}
}

})